var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logo-wrapper",style:({ transform: `scale(${_vm.scale})` })},[_c('v-img',{attrs:{"src":require('@/assets/images/calearna-logotype.png')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }